// extracted by mini-css-extract-plugin
module.exports = {"brand":"Header_brand__2yYDN","up":"Header_up__3ia0l"};